import { Navigate } from 'react-router-dom';
import { Suspense } from 'react';
import { ProgressBar } from '@/components/ProgressBar';
import { BreadcrumbLink, RouteObjectWithBreadcrumbs } from '@/components/Breadcrumbs';

import { ErpPaths } from '@/router/paths/erp.paths';
import { Outlet } from 'react-router';

export const ErpRoute: RouteObjectWithBreadcrumbs = {
  path: ErpPaths.ROOT_PATH,
  handle: {
    breadcrumb: {
      Component: () => <BreadcrumbLink to={ErpPaths.ROOT_PATH}>ERP</BreadcrumbLink>,
    },
  },
  children: [
    {
      index: true,
      element: <Navigate replace to={ErpPaths.EQUIPMENT_PATH} />,
    },
    {
      path: ErpPaths.EQUIPMENT_PATH,
      element: <Outlet />,
      handle: {
        breadcrumb: {
          Component: () => <BreadcrumbLink to={ErpPaths.EQUIPMENT_PATH}>Оборудование</BreadcrumbLink>,
        },
      },
      children: [
        {
          index: true,
          lazy: async () => {
            const { EquipmentPage } = await import(
              /* webpackChunkName: "EquipmentPage" */
              '@/pages/erp'
            );

            return {
              Component: () => (
                <Suspense fallback={<ProgressBar />}>
                  <EquipmentPage />
                </Suspense>
              ),
            };
          },
        },
      ],
    },
    {
      path: ErpPaths.USER_LICENSES_PATH,
      lazy: async () => {
        const { UserLicensesPage } = await import(
          /* webpackChunkName: "UserLicensesPage" */
          '@/pages/erp'
        );

        return {
          Component: () => (
            <Suspense fallback={<ProgressBar />}>
              <UserLicensesPage />
            </Suspense>
          ),
        };
      },
      handle: {
        breadcrumb: () => ({
          Component: () => <BreadcrumbLink to={ErpPaths.USER_LICENSES_PATH}>Лицензии</BreadcrumbLink>,
        }),
      },
    },
    {
      path: ErpPaths.PAYMENT_GATEWAYS_PATH,
      lazy: async () => {
        const { PaymentGatewaysPage } = await import(
          /* webpackChunkName: "PaymentGatewaysPage" */
          '@/pages/erp'
        );

        return {
          Component: () => (
            <Suspense fallback={<ProgressBar />}>
              <PaymentGatewaysPage />
            </Suspense>
          ),
        };
      },
      handle: {
        breadcrumb: {
          Component: () => <BreadcrumbLink to={ErpPaths.PAYMENT_GATEWAYS_PATH}>Платежные шлюзы</BreadcrumbLink>,
        },
      },
    },
  ],
};
